import React, {useState} from "react";

/*
Collapsible section for detail views.
Renders a header (badge + title + subtitle on the left, amount + chevron on the right)
and, when open, the children inside the body.
*/
export function CollapsibleSection({
                                  badge = null,
                                  title,
                                  subtitle = null,
                                  amountLabel = null,
                                  amount = null,
                                  defaultOpen = false,
                                  collapsible = true,
                                  children,
                              }) {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const open = collapsible ? isOpen : true;
    // A section can be there with nothing to show, to say so in its header.
    const hasBody = React.Children.toArray(children).some(child => child !== '' && child !== null);

    return (
        <div className="ds-section">
            <div
                className={`ds-section-header ${collapsible ? 'ds-section-header-clickable' : ''}`}
                onClick={collapsible ? () => setIsOpen(prev => !prev) : undefined}
                onKeyDown={collapsible ? (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setIsOpen(prev => !prev);
                    }
                } : undefined}
                role={collapsible ? 'button' : undefined}
                tabIndex={collapsible ? 0 : undefined}
                aria-expanded={collapsible ? open : undefined}
            >
                <div className="ds-section-header-left">
                    {badge ?
                        <span className="ds-badge">{badge}</span>
                    : ''}
                    <span className="ds-section-title">{title}</span>
                    {subtitle ?
                        <span className="ds-section-subtitle">{subtitle}</span>
                    : ''}
                </div>
                <div className="ds-section-header-right">
                    {amount !== null && amount !== undefined ?
                        <span>
                            {amountLabel ?
                                <span className="ds-section-amount-label">{amountLabel} </span>
                            : ''}
                            <span className="ds-section-amount">{amount}</span>
                        </span>
                    : ''}
                    {collapsible ?
                        <i className={`bx ${open ? 'bx-caret-up' : 'bx-caret-down'} ds-chevron`} />
                    : ''}
                </div>
            </div>

            {open && hasBody ?
                <div className="ds-section-body">
                    {children}
                </div>
            : ''}
        </div>
    );
}
